import React, { Fragment } from 'react';
import { Breadcrumb, Tab } from 'semantic-ui-react';
import Dashboard from './Dashboard.jsx';
import PaymentDeviceStatusHistory from './PaymentDeviceStatusHistory.jsx';

export default function Reports({
  storesLink,
  calendarDataPath,
  oldestDateInMs,
  ...props
}) {
  return (
    <Fragment>
      <header className={'io-form-header'}>
        <h2>Reports</h2>

        <Breadcrumb className='reports-breadcrumb'>
          <Breadcrumb.Section
            content='Stores'
            href={storesLink}
          />
          <Breadcrumb.Divider icon='right chevron' />
          <Breadcrumb.Section
            active
            content='Reports'
          />
        </Breadcrumb>
      </header>

      <Tab
        menu={{ secondary: true, pointing: true }}
        panes={[
          {
            menuItem: 'Dashboard',
            render: () => (
              <Tab.Pane
                as={Dashboard}
                {...props}
              />
            ),
          },
          {
            menuItem: 'Payment Device Status Calendar',
            render: () => (
              <Tab.Pane
                as={PaymentDeviceStatusHistory}
                fetchPath={calendarDataPath}
                minDateValue={oldestDateInMs}
              />
            ),
          },
        ]}
      />
    </Fragment>
  );
}
